var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tree',{attrs:{"nodes":_vm.nodes},model:{value:(_vm.selectedOrgUnit),callback:function ($$v) {_vm.selectedOrgUnit=$$v},expression:"selectedOrgUnit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }